import React from 'react';
import { Card, CardBody, Typography } from "@material-tailwind/react";

const TaskPageHeader = ({ title, subtitle, actions = null, icon = null, meta = null }) => {
    return (
        <Card className="shadow-sm border border-white/70">
            <CardBody className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                <div className="flex items-start gap-4">
                    {icon && (
                        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-50 text-[#FF5733]">
                            {icon}
                        </div>
                    )}
                    <div>
                        <Typography variant="h4" color="blue-gray" className="font-bold">
                            {title}
                        </Typography>
                        {subtitle && (
                            <Typography variant="small" color="gray" className="mt-1 max-w-3xl">
                                {subtitle}
                            </Typography>
                        )}
                        {meta && <div className="mt-3">{meta}</div>}
                    </div>
                </div>

                {actions && (
                    <div className="flex flex-wrap items-center gap-2">
                        {actions}
                    </div>
                )}
            </CardBody>
        </Card>
    );
};

export default TaskPageHeader;
